<script>

export default {
  timer: 0,
  data() {
    return {
      date: new Date(),
    };
  },
  mounted() {
    this.setTime();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    setTime() {
      this.timer = setTimeout(() => {
        this.date = new Date();
        this.setTime();
      }, 60000);
    },
  },
};
</script>

<template lang="pug">
div {{ date | formatTime }}
</template>

<style module lang="sass">
.root
  overflow: hidden
  border-radius: 50%
.pic
  height: 100%
  width: 100%
  background-size: cover
  background-repeat: no-repeat
.normal
  width: 40px
  height: 40px
.large
  width: 60px
  height: 60px
.light
  color: $color_bg_light_accent
  background: $color_bg_light
.dark
  color: $white
  background: $color_bg_dark
.ico
  height: 100%
  width: 100%
  display: block

</style>
